var ListboxLooks;
(function (ListboxLooks) {
  ListboxLooks["Default"] = 'default';
})(ListboxLooks || (ListboxLooks = {}));
export { ListboxLooks };